import { jsx as o } from "react/jsx-runtime";
const e = ({ width: t, height: n, className: r }) => /* @__PURE__ */ o(
  "svg",
  {
    className: r,
    fill: "none",
    height: n,
    viewBox: "0 0 6 6",
    width: t,
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ o(
      "path",
      {
        d: "M6 2.99988C6 4.65673 4.65685 5.99988 3 5.99988C1.34315 5.99988 0 4.65673 0 2.99988C0 1.34302 1.34315 -0.00012207 3 -0.00012207C4.65685 -0.00012207 6 1.34302 6 2.99988Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  e as Content
};
